import React from 'react';
import { Typography, Grid, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { MasterRouteLanding } from "../pages/utility";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";



export default function HomeInventory({ firstName, loginuser }) {
    //console.log("props", loginuser);
    const landingMenuItems =
        useSelector((state) => state.storeLandingMenuItemsReducer.menuItems) || [];

    //console.log(localStorage.getItem('physicalLanndingMenuesItems'));


    useEffect(() => {
        if (landingMenuItems && landingMenuItems.length > 0) {
            localStorage.setItem(
                'physicalLanndingMenuesItems',
                JSON.stringify(landingMenuItems)
            );
        }
        //console.log('landingMenuItems',landingMenuItems);
    }, [landingMenuItems]);
   // const physicalLanndingMenuesItems = JSON.parse(localStorage.getItem('physicalLanndingMenuesItems')) || [];

    return (

        <Grid container spacing={1} className="position-relative">
            <Grid item xs={12} className="home-user-description">
                <Grid item xs={12} className="description-block">
                    <div className="d-flex">
                        <div className="description-bdr"></div>
                        <h1 className="mt-0 get-MyId-username clr-white"> Hello, {firstName}</h1>
                        {/*<h1 className="mt-0 get-MyId-username clr-white"> Hello, {firstName} {lastName}</h1>*/}


                    </div>
                    <Typography className="clr-white project-desc">
                        Welcome to Physical Inventory

                    </Typography>


                    <Grid container spacing={0}>
                        {
                            landingMenuItems?.length > 0 &&
                                (<Grid container spacing={0}>
                                    {landingMenuItems.map((item, index) => (
                                        <Grid item xs={10} sm={6} md={4} key={index}>
                                            <Link to={item.menuLink} key={index}>
                                                <div className="menu-item-container">
                                                    <div className="menu-item-text-block">
                                                        <Button variant="contained" className="homepage-master-btn ns-btn-hero">
                                                            <span className="f-20 fw-bold"> {item.menuName}</span>



                                                        </Button>

                                                    </div>
                                                </div>
                                            </Link>
                                        </Grid>
                                    ))}
                                </Grid>) 
                        }

                    </Grid>

                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} className="cognisphere-vid-block" id="CognisphereVid">
                <video autoPlay loop muted className="width-100 height-100">
                    <source src={"../assets/animation/cognisphere_home.mp4"} type="video/mp4" />
                </video>
            </Grid>
        </Grid>)
}


//export default function HomeInventory({ firstName, lastName }) {
//    return (
//        <Grid container spacing={1} className="position-relative">
//            <Grid item xs={12} className="home-user-description">
//                <Grid xs={12} className="description-block">
//                    <div className="d-flex">
//                        <div className="description-bdr"></div>
//                        <h1 className="mt-0 get-MyId-username clr-white"> Hello, {firstName} {lastName}</h1>


//                    </div>
//                    <Typography className="clr-white project-desc">
//                        Welcome to Physical Inventory

//                    </Typography>
//                    <Grid xs={12} >
//                        <Button variant="contained" component={Link} to="/SlipInventory" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Slip Creation</span>
//                        </Button>
//                        <Button variant="contained" component={Link} to="/ModifyInventory" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">View / Modify Slip</span>
//                        </Button>
//                        {/*<Button variant="contained" component={Link} to="/UpdateSlipInventory" className="homepage-master-btn ns-btn-hero">*/}
//                        {/*    <span className="f-20 fw-bold">Modify Slip</span>*/}
//                        {/*</Button>*/}
//                        <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

//                        </Grid>
//                        <Button variant="contained" component={Link} to="/AuditInventory" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Audit Creation</span>
//                        </Button>
//                        <Button variant="contained" component={Link} to="/ViewAuditInventory" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">View Audit</span>
//                        </Button>
//                        {/*<Button variant="contained" component={Link} to="/SlipInventory" className="homepage-master-btn ns-btn-hero">*/}
//                        {/*    <span className="f-20 fw-bold">Slip Creation</span>*/}
//                        {/*</Button>*/}
//                        <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

//                        </Grid>
//                        <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

//                        </Grid>
//                        <Button variant="contained" component={Link} to="/MRPController" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">MRP Controller</span>
//                        </Button>
//                        <Button variant="contained" component={Link} to="/SummaryReport" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Material Report</span>
//                        </Button>
//                        <Button variant="contained" component={Link} to="/LocationReport" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Location Report</span>
//                        </Button>
//                        <Grid item xs={12} sm={3} className="d-flex jc-center width-100">

//                        </Grid>
//                        <Button variant="contained" component={Link} to="/SapUpload" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Sap Upload</span>
//                        </Button>

//                        <Button variant="contained" component={Link} to="/BulkSlipCreation" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">Bulk Creation</span>
//                        </Button>
//                        <Button variant="contained" component={Link} to="/UserMgntFile" className="homepage-master-btn ns-btn-hero">
//                            <span className="f-20 fw-bold">User Management</span>
//                        </Button>


//                    </Grid>
//                </Grid>
//            </Grid>

//            <Grid item xs={12} sm={6} className="cognisphere-vid-block" id="CognisphereVid">
//                <video autoPlay loop muted className="width-100 height-100">
//                    <source src={"../assets/animation/cognisphere_home.mp4"} type="video/mp4" />
//                </video>
//            </Grid>
//        </Grid>
//    );
//}
